import React from 'react';
import { motion } from 'framer-motion';

const TransientThoughtBubble = ({
  config, disableBubble, initiateAnimation, variants, fillColor, textColor, fontFamily, fontSize
}) => {
  const getRelativeTextPosition = ({ id }) => {
    const top = id === 'bl' || id === 'br' ? '-top-24' : '-top-22';
    const left = id === 'cl' ? '-left-70' : '-left-72';
    return `absolute w-170 ${top} ${left} text-[${fontSize}] h-56`;
  };

  return (
    <div
      className={config.className} >
      <motion.svg
        animate={config.animate}
        initial={{ opacity: 0 }}
        transition={config.transition}
        onAnimationComplete={disableBubble}
        width={114} height={46} xmlns="http://www.w3.org/2000/svg" fill="none">
        <motion.path
          initial={{ pathLength: 0 }}
          custom={config.transition?.delay || 0}
          onAnimationComplete={initiateAnimation}
          animate={'visible'}
          variants={variants}
          fillRule="evenodd" clipRule="evenodd" stroke="black" strokeWidth={0.5} d={config.d}
          fill={fillColor}
        ></motion.path>
        {config.ellipse ? <motion.ellipse {...config.ellipse} fill={fillColor} ></motion.ellipse> : <motion.path d={config.path} fill={fillColor} stroke='black' strokeWidth='0.5' />}
      </motion.svg>
      <motion.div
        animate={{
          ...config.animate, scale: config.animate.scale === 7 ? 1 : 0.14
        }}
        initial={{ opacity: 0, scale: 0.14 }}
        transition={config.transition}
        lang='en' style={{
          color: textColor,
          lineHeight: 1.5,
          wordWrap: 'anywhere',
          fontFamily,
          fontSize
        }} className={`flex justify-center items-center text-center  ${getRelativeTextPosition(config)}`}>
        {config.words.split(' ').length > 44 ? `${config.words.split(' ').slice(0, 40).join(' ')}...` : config.words}
      </motion.div>
    </div>
  );
};

export default TransientThoughtBubble;
